import { getNewsletterDefault } from './newsletterDefault'

// SPEC-099: the optional newsletter opt-in shown wherever an account is
// created. The backend stores the exact sentence from its own settings,
// keyed by this version: change the copy → bump the version there too.
export const ACCOUNT_CONSENT_TEXT_VERSION = '2026-10-account'

// SPEC-099 D9 / SPEC-101 D2 (Nate + Matt): the short text. Nothing on
// production has recorded consent yet, so 2026-10-account takes this text.
export const NEWSLETTER_CONSENT_LABEL =
  'Send me the free weekly newsletter and occasional offers. Unsubscribe anytime.'
export const PRIVACY_POLICY_URL =
  'https://www.stanwinstonschool.com/customer-care/privacy-policy/'

// The fields an account-creation request carries. Only a surface that shows
// the box has an answer (true or false); everywhere else (LoginBox, OTP…)
// nothing is sent, so the backend treats the account as not consenting.
// SPEC-109 D5: whether the person touched the box themselves travels with
// the answer (marketing_consent_touched), so a default tick never
// subscribes an existing account — only their own tick does.
export const accountConsentPayload = (marketingConsent, touched = false) =>
  typeof marketingConsent === 'boolean'
    ? {
        marketingConsent,
        consentTextVersion: ACCOUNT_CONSENT_TEXT_VERSION,
        marketingConsentTouched: Boolean(touched)
      }
    : {}

// The same answer for analytics (PostHog / GA4), when there is one. SPEC-109
// FR-6: with how the box started (the backend's per-country default), whether
// the person touched it, and the country the default came from, when that
// answer had arrived.
export const accountConsentEventProps = (marketingConsent, touched = false) => {
  if (typeof marketingConsent !== 'boolean') return {}
  const props = {
    marketing_consent_shown: true,
    marketing_consent: marketingConsent,
    marketing_consent_touched: Boolean(touched)
  }
  const defaults = getNewsletterDefault()
  if (defaults) {
    props.newsletter_default_ticked = defaults.defaultTicked
    if (defaults.country) props.country = defaults.country
  }
  return props
}

// SPEC-109 follow-up (Pedro, 2026-10-23: label the event only): a social
// click on the login page can create an account with no box in sight
// (SPEC-099 D7), and the event used to say nothing — indistinguishable from
// a missing property. The social dispatchers read the answer from the
// button's props; a login-page button has none and says so instead.
// Nothing changes in what the backend receives.
export const LOGIN_PAGE_SURFACE = 'login_page'
export const socialEventProps = (props = {}) => {
  if (typeof props.marketingConsent === 'boolean')
    return accountConsentEventProps(
      props.marketingConsent,
      props.marketingConsentTouched
    )
  if (props.eventSurface !== LOGIN_PAGE_SURFACE) return {}
  const out = {
    marketing_consent_shown: false,
    signup_surface: LOGIN_PAGE_SURFACE
  }
  const defaults = getNewsletterDefault()
  if (defaults) {
    out.newsletter_default_ticked = defaults.defaultTicked
    if (defaults.country) out.country = defaults.country
  }
  return out
}

// SPEC-117: where a free account was created. Only the /users/signup page
// says so (`signup_page`); the backend tags those new accounts for the
// welcome series when the newsletter box was ticked. Any other surface
// (checkout, the plans-page step, /login create, gift) sends nothing.
export const SIGNUP_PAGE_SURFACE = 'signup_page'
export const signupSurfacePayload = (signupSurface) =>
  signupSurface ? { signupSurface } : {}
